import { format, isValid, parseISO } from 'date-fns';

/** Missing or invalid date placeholder for document tables. */
export const TABLE_DATE_PLACEHOLDER = '—';

/** Formats a non-empty ISO date string. Returns `—` if invalid. */
const formatIsoDateValue = (
  value: string,
  formatString = 'MM/dd/yyyy',
): string => {
  const parsedDate = parseISO(value);
  return isValid(parsedDate)
    ? format(parsedDate, formatString)
    : TABLE_DATE_PLACEHOLDER;
};

/** Date-only API fields (e.g. `dateOfStudy`). Example: `'2024-06-15'` → `'06/15/2024'`. */
export const formatTableDate = (value?: string | null): string => {
  if (!value) return TABLE_DATE_PLACEHOLDER;
  return formatIsoDateValue(value);
};

/** Timestamp fields (e.g. `createdAt`). Example: `'2024-06-15T14:22:00Z'` → `'06/15/2024'`. */
export const formatTableTimestamp = (value?: Date | string | null): string => {
  if (!value) return TABLE_DATE_PLACEHOLDER;
  const parsedDate = value instanceof Date ? value : new Date(value);
  return isValid(parsedDate)
    ? format(parsedDate, 'MM/dd/yyyy')
    : TABLE_DATE_PLACEHOLDER;
};
